export default Object.freeze({
  'title': '',
  'type': 'bar-horizontal',
  'labelY': null,
  'labelX': null,
  'labels': null,
  'dataSeries': []
});




// WEBPACK FOOTER //
// ./src/pages/Reports/defaultChartData.js